import { useState } from 'react';

const faqs = [
  {
    question: 'Where can I take art classes near Nazareth, PA?',
    answer: 'Art Den Studio is located at 37 E Belvidere Street in Nazareth, PA, offering art classes year-round for kids and adults. Sessions can be booked online through the studio calendar. Easily accessible from Bethlehem, Easton, Allentown, and across the Lehigh Valley.',
  },
  {
    question: 'Does Art Den Studio offer kids art classes?',
    answer: 'Yes! Art Den Studio offers creative, guided painting sessions specifically designed for children ages 4 and up. Kids classes are age-appropriate, fun, and welcoming to all skill levels. Young artists take home their original finished artwork at the end of every session.',
  },
  {
    question: 'What adult class options are available at Art Den Studio?',
    answer: 'Art Den Studio offers guided painting nights, open studio sessions, themed events, and private group experiences for adults. Whether you want a relaxing solo session or a social night out with friends, there\'s always something on the calendar.',
  },
  {
    question: 'Can I book a birthday party at Art Den Studio?',
    answer: 'Absolutely. Birthday parties are one of the most popular offerings. Kids and adults can celebrate with a private, guided painting session. Kelsey leads the group through a fun art project and every guest leaves with a finished piece they\'re proud of.',
  },
  {
    question: 'How much do art classes cost at Art Den Studio?',
    answer: 'Pricing varies by session type, duration, and group size. Individual class rates and private party packages are listed on the studio\'s booking calendar. Gift cards are also available. For specific pricing, contact Art Den Studio at 610-340-0314 or info@artdenstudio.com.',
  },
  {
    question: 'Do I need to bring my own art supplies?',
    answer: 'No — everything is provided. Art Den Studio supplies all canvases, paints, brushes, and materials for every session. Just show up ready to create. There\'s nothing to prep, pack, or bring.',
  },
];

const FAQ = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 relative" style={{ background: '#f6f1eb' }}>
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 mb-5 justify-center">
            <div className="h-px w-8 bg-artden-coral" />
            <span className="section-label">Frequently Asked</span>
            <div className="h-px w-8 bg-artden-coral" />
          </div>
          <h2 className="font-cormorant font-medium text-artden-dark leading-[1.0] tracking-tight" style={{ fontSize: 'clamp(2.2rem, 4.5vw, 4rem)' }}>
            Questions & Answers
          </h2>
          <p className="font-outfit text-artden-mid text-sm mt-3">Optimized for voice search and AI assistants</p>
        </div>

        {/* Accordion */}
        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl overflow-hidden border transition-all duration-300 ${
                open === i
                  ? 'border-artden-coral/20 bg-white'
                  : 'border-artden-canvas bg-white/50 hover:bg-white/80'
              }`}
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <h3 className="font-outfit text-artden-dark text-sm md:text-base font-medium leading-snug">
                  {faq.question}
                </h3>
                <span
                  className="w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-all"
                  style={{ background: open === i ? 'rgba(255,67,34,0.1)' : '#e8dfd0' }}
                >
                  <i
                    className={`text-sm transition-transform duration-300 ${open === i ? 'ri-subtract-line text-artden-coral' : 'ri-add-line text-artden-mid'}`}
                  ></i>
                </span>
              </button>
              <div
                className="overflow-hidden transition-all duration-300"
                style={{ maxHeight: open === i ? '300px' : '0px' }}
              >
                <div className="px-5 md:px-6 pb-5">
                  <p className="font-outfit text-artden-mid text-sm leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom links */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 mt-10">
          <a
            href="/faqs"
            className="inline-flex items-center gap-2 border border-artden-dark/20 hover:border-artden-coral text-artden-dark hover:text-artden-coral text-sm font-outfit font-medium px-6 py-3 rounded-full transition-all whitespace-nowrap"
          >
            View All FAQs
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
          <a
            href="/contact"
            className="inline-flex items-center gap-2 text-artden-coral hover:brightness-75 text-sm font-outfit font-medium transition-all whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-question-answer-line"></i>
            </span>
            Ask Your Own Question
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
